import "./Menu.scss";
import React, { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const Menu = () => {
  const menuList = useSelector((state) => state.menuAuth.menuAuthInfo);
  const [activeMenuId, setActiveMenuId] = useState(null);
  const { t } = useTranslation();

  const buildMenuHierarchy = (flatList) => {
    const majorMap = {};
    const middleMap = {};

    flatList.forEach((menu) => {
      const { menuLevel, menuMajorCode, menuMiddleCode } = menu;

      const menuNode = {
        id: menu.id,
        menuNameCd: menu.menuNameCd,
        url: menu.url,
        view: menu.view,
        children: [],
      };

      if (menuLevel === 0 && menuNode.view) {
        majorMap[menuMajorCode] = menuNode;
      } else if (menuLevel === 1 && menuNode.view) {
        const key = `${menuMajorCode}-${menuMiddleCode}`;
        middleMap[key] = menuNode;

        const parent = majorMap[menuMajorCode];
        if (parent) {
          parent.children.push(menuNode);
        }
      } else if (menuLevel === 2 && menuNode.view) {
        const middleKey = `${menuMajorCode}-${menuMiddleCode}`;
        const parent = middleMap[middleKey];
        if (parent) {
          parent.children.push(menuNode);
        }
      }
    });

    return Object.values(majorMap);
  };

  const menuTree = useMemo(() => {
    if (!menuList || menuList.length === 0) return [];
    return buildMenuHierarchy(menuList);
  }, [menuList]);

  const handleMenu = (menu) => {
    setActiveMenuId((prev) => (prev === menu.id ? null : menu.id));
  };

  return (
    <div className="gnb_wrap">
      <ul className="main_area">
        {menuTree && menuTree.length > 0 ? (
          menuTree.map((menu) => (
            <li
              key={menu.id}
              className={menu.id === activeMenuId ? "active" : ""}
            >
              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleMenu(menu);
                }}
              >
                {t(`MENU:${menu.menuNameCd}`)}
              </Link>
              <div className="sub_area">
                <div className="sub_wrap">
                  {menu.children?.map((subMenu) => (
                    <dl key={subMenu.id}>
                      {subMenu.children?.map((subSubMenu) => (
                        <dt key={subSubMenu.id}>
                          <Link
                            to={subSubMenu.url}
                            onClick={() => setActiveMenuId(null)}
                          >
                            {t(`MENU:${subSubMenu.menuNameCd}`)}
                          </Link>
                        </dt>
                      ))}
                    </dl>
                  ))}
                </div>
              </div>
            </li>
          ))
        ) : (
          <></>
        )}
      </ul>
    </div>
  );
};

export default Menu;
